import { BrandLogo, HeroImage } from '@brightdrop/bd-ui';
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

import useStyles from './InvalidInviteTemplate.style';

export interface InvalidInviteTemplateProps {
  header: string;
  message: string;
  /** Rendered below the message. */
  action?: ReactNode;
}

const InvalidInviteTemplate = (
  props: InvalidInviteTemplateProps
): JSX.Element => {
  const { classes } = useStyles();

  return (
    <div className={classes.templateWrapper}>
      <HeroImage className={classes.templateLeftCol} />
      <div className={classes.templateRightCol}>
        <div className={classes.templateContent}>
          <div className={classes.companyLogo}>
            <BrandLogo />
          </div>
          <div className={classes.messageContainer}>
            <Typography
              variant="header1_medium"
              className={classes.messageHeader}
            >
              {props.header}
            </Typography>
            <Typography variant={'body_regular'}>{props.message}</Typography>
            {props.action && (
              <div className={classes.actionContainer}>{props.action}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvalidInviteTemplate;
